import styled from 'styled-components';

export const AddFilterPopoverContent = styled.div`
    padding: 16px;
    min-width: 190px;
`;
